import { render, staticRenderFns } from "./ProfessionReformSelector.vue?vue&type=template&id=ba81e4aa&"
import script from "./ProfessionReformSelector.vue?vue&type=script&lang=js&"
export * from "./ProfessionReformSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
